export function tenderSlug(id: number, title: string): string {
  const slug = title
    .replace(/\s+/g, "-")
    .replace(/[^\p{L}\p{N}-]/gu, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
  return `${id}-${slug || "tender"}`;
}
